<div>
  <div class='flex flex--justify-content-center'  *ngIf="imageUrl">
    <img height={{imageHeight}} [src]="imageUrl" [alt]="title">
  </div>
  <div class='text-center'>
    <h4 class='text-dark-blue'>
      {{ title }}
    </h4>
    <p *ngIf="description">
      {{ description }}
    </p>
  </div>
</div>
